import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const ItineraryRecommendation = ({ itinerary, onSelect }) => {
  return (
    <div className="bg-[var(--color-card)] rounded-lg overflow-hidden border border-[var(--color-border)] hover:border-[var(--color-primary)] transition-all duration-300 hover:shadow-conservation cursor-pointer"
         onClick={() => onSelect(itinerary?.id)}>
      <div className="relative h-48 overflow-hidden">
        <Image 
          src={itinerary?.image} 
          alt={itinerary?.imageAlt}
          className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-3 right-3 bg-[var(--color-accent)] text-[var(--color-accent-foreground)] px-3 py-1 rounded-full text-xs font-medium">
          {itinerary?.difficulty}
        </div>
      </div>
      <div className="p-5">
        <div className="flex items-start justify-between mb-3">
          <h3 className="text-lg font-semibold text-[var(--color-foreground)]">{itinerary?.name}</h3>
          <div className="flex items-center gap-1 text-[var(--color-accent)]">
            <Icon name="Star" size={16} />
            <span className="text-sm font-medium">{itinerary?.rating}</span>
          </div>
        </div>

        <p className="text-sm text-[var(--color-muted-foreground)] mb-4 leading-relaxed">
          {itinerary?.description}
        </p>

        <div className="grid grid-cols-3 gap-3 mb-4">
          <div className="flex items-center gap-2">
            <Icon name="Clock" size={16} color="var(--color-muted-foreground)" />
            <span className="text-xs text-[var(--color-foreground)]">{itinerary?.duration}</span>
          </div>
          <div className="flex items-center gap-2">
            <Icon name="TrendingUp" size={16} color="var(--color-muted-foreground)" />
            <span className="text-xs text-[var(--color-foreground)]">{itinerary?.elevation}</span>
          </div>
          <div className="flex items-center gap-2">
            <Icon name="MapPin" size={16} color="var(--color-muted-foreground)" />
            <span className="text-xs text-[var(--color-foreground)]">{itinerary?.distance}</span>
          </div>
        </div>

        <div className="space-y-2 mb-4">
          <p className="text-xs font-medium text-[var(--color-foreground)]">Highlights:</p>
          {itinerary?.highlights?.map((highlight, index) => (
            <div key={index} className="flex items-start gap-2">
              <Icon name="Check" size={14} color="var(--color-success)" className="mt-0.5" />
              <span className="text-xs text-[var(--color-muted-foreground)]">{highlight}</span>
            </div>
          ))}
        </div>

        <div className="flex items-center justify-between pt-4 border-t border-[var(--color-border)]">
          <div className="flex items-center gap-2">
            <Icon name="Users" size={16} color="var(--color-muted-foreground)" />
            <span className="text-xs text-[var(--color-foreground)]">{itinerary?.groupSize}</span>
          </div>
          <span className="text-sm font-semibold text-[var(--color-accent)]">
            View Details →
          </span>
        </div>
      </div>
    </div>
  );
};

export default ItineraryRecommendation;